import React from "react";

import "./App.css";
import PurchaseList from "./components/Purchases/PurchaseList";

function App() {
  return (
    <div className="App">
      <PurchaseList />
    </div>
  );
}

export default App;
